import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/music_2024/controls.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/music_2024/opengraph-image.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/music_2024/watchReplay.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
